import { useCallback } from 'react';
import {
  alpha,
  Box,
  ToggleButton,
  ToggleButtonGroup,
  useTheme
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import {
  useSpreadsheetViewType,
  useSetSpreadsheetViewType,
  type CampaignSpreadsheetViewType
} from '../../context/CampaignContext';

const SpreadsheetViewToggle = () => {
  const theme = useTheme();
  const spreadsheetViewType = useSpreadsheetViewType();
  const setSpreadsheetViewType = useSetSpreadsheetViewType();
  const accountAccent = theme.customColors.spreadsheetAccountAccent;
  const leadAccent = theme.customColors.spreadsheetLeadAccent;

  const handleChange = useCallback(
    (
      _: React.MouseEvent<HTMLElement>,
      newValue: CampaignSpreadsheetViewType | null
    ) => {
      if (newValue !== null) {
        setSpreadsheetViewType(newValue);
      }
    },
    [setSpreadsheetViewType]
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <ToggleButtonGroup
        value={spreadsheetViewType}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{
          '& .MuiToggleButton-root': {
            px: 1.5,
            py: 0.25,
            fontSize: '12px',
            textTransform: 'none'
          }
        }}
      >
        <ToggleButton
          value="account"
          sx={{
            '&.Mui-selected': {
              backgroundColor: alpha(accountAccent, 0.14),
              color: accountAccent,
              '&:hover': { backgroundColor: alpha(accountAccent, 0.2) }
            }
          }}
        >
          <BusinessIcon sx={{ fontSize: 16, mr: 0.5 }} />
          Accounts
        </ToggleButton>
        <ToggleButton
          value="lead"
          sx={{
            '&.Mui-selected': {
              backgroundColor: alpha(leadAccent, 0.14),
              color: leadAccent,
              '&:hover': { backgroundColor: alpha(leadAccent, 0.2) }
            }
          }}
        >
          <PersonIcon sx={{ fontSize: 16, mr: 0.5 }} />
          Leads
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default SpreadsheetViewToggle;
